<div class="filter-wrapper">
    <ham-filter
        [searchButtonLabel]="'aumico_core_table_filter_placeholder' | i18next"
        [placeholder]="'aumico_reports_notes_search_reports' | i18next"
        (filter)="filterChecklists($event)"
    ></ham-filter>
</div>
<ham-table [dataSource]="checklists" [pageSize]="5" (rowSelected)="onRowSelected($event)">
    <!-- Header Definitions -->
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_checklist_management_table_checklist_name' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell hamDateCol>
        {{ 'aumico_checklist_management_table_checklist_last_change' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_checklist_management_table_checklist_modified_by' | i18next }}
    </ng-template>

    <!-- Cell Definitions -->
    <ng-template hamCell let-element hamTextCol> {{ element.name }} </ng-template>
    <ng-template hamCell let-element hamDateCol> {{ element.updatedAt | dateLocale }} </ng-template>
    <ng-template hamCell let-element hamTextCol> {{ element.updatedBy }} </ng-template>
</ham-table>
